export interface Device {
  id: string;
  deviceNo: string;
  /** glass = AI眼镜, phone = 手机 (1-1 paired with a glass) */
  deviceType?: "glass" | "phone";
  /** stable hardware fingerprint (unique device identity) */
  hardwareId?: string | null;
  mac: string;
  model: string;
  battery: number;
  status: "online" | "weak" | "offline" | "low_battery" | "maintenance";
  boundVisitor: string | null;
  trip: string | null;
  pairingCode: string | null;
  pairedDeviceId?: string | null;
  pairedDeviceNo?: string | null;
  lastOnline: string;
  firmware: string;
  ship: string;
  group: string;
  /** last heartbeat position, WGS-84; 0 = never reported */
  lastLat?: number;
  lastLng?: number;
  /** when the fix was actually taken (≠ heartbeat/lastOnline time) */
  lastPosAt?: string;
  /** phone 采集模式 on (1s heartbeat); 讲解点采集录制页只列开启的设备 */
  captureMode?: boolean;
}

export const deviceStats = {
  total: 0,
  glass: 0,
  phone: 0,
  registered: 0,
  placeholder: 0,
  online: 0,
  lowBattery: 0,
  maintenance: 0,
  borrowed: 0,
  issued: 0,
};

export const devices: Device[] = [
  {
    id: "1",
    deviceNo: "A001",
    mac: "AC:23:3F:A4:12:B1",
    model: "TG-V2 Pro",
    battery: 87,
    status: "online",
    boundVisitor: "陈明远",
    trip: "YC20260601-A",
    pairingCode: "384291",
    lastOnline: "2026-06-01 14:32:18",
    firmware: "v2.3.1",
    ship: "长江壹号",
    group: "上午批次",
  },
  {
    id: "2",
    deviceNo: "A002",
    mac: "AC:23:3F:A4:12:B2",
    model: "TG-V2 Pro",
    battery: 62,
    status: "online",
    boundVisitor: "王建国",
    trip: "YC20260601-A",
    pairingCode: "482039",
    lastOnline: "2026-06-01 14:30:05",
    firmware: "v2.3.1",
    ship: "长江壹号",
    group: "上午批次",
  },
  {
    id: "3",
    deviceNo: "A003",
    mac: "AC:23:3F:A4:12:B3",
    model: "TG-V2 Lite",
    battery: 15,
    status: "low_battery",
    boundVisitor: "李婷",
    trip: "YC20260601-A",
    pairingCode: "572814",
    lastOnline: "2026-06-01 14:15:33",
    firmware: "v2.2.8",
    ship: "长江壹号",
    group: "上午批次",
  },
  {
    id: "4",
    deviceNo: "A004",
    mac: "AC:23:3F:A4:12:B4",
    model: "TG-V2 Pro",
    battery: 91,
    status: "online",
    boundVisitor: "张伟",
    trip: "YC20260601-B",
    pairingCode: "683920",
    lastOnline: "2026-06-01 14:28:47",
    firmware: "v2.3.1",
    ship: "三峡盛世",
    group: "下午批次",
  },
  {
    id: "5",
    deviceNo: "A005",
    mac: "AC:23:3F:A4:12:B5",
    model: "TG-V2 Pro",
    battery: 45,
    status: "weak",
    boundVisitor: "刘芳",
    trip: "YC20260601-B",
    pairingCode: "194756",
    lastOnline: "2026-06-01 14:05:12",
    firmware: "v2.3.0",
    ship: "三峡盛世",
    group: "下午批次",
  },
  {
    id: "6",
    deviceNo: "A006",
    mac: "AC:23:3F:A4:12:B6",
    model: "TG-V2 Lite",
    battery: 78,
    status: "online",
    boundVisitor: null,
    trip: null,
    pairingCode: null,
    lastOnline: "2026-06-01 13:50:22",
    firmware: "v2.2.8",
    ship: "长江壹号",
    group: "备用",
  },
  {
    id: "7",
    deviceNo: "A007",
    mac: "AC:23:3F:A4:12:B7",
    model: "TG-V2 Pro",
    battery: 33,
    status: "offline",
    boundVisitor: "赵强",
    trip: "YC20260601-A",
    pairingCode: "837460",
    lastOnline: "2026-06-01 12:18:45",
    firmware: "v2.3.1",
    ship: "长江壹号",
    group: "上午批次",
  },
  {
    id: "8",
    deviceNo: "A008",
    mac: "AC:23:3F:A4:12:B8",
    model: "TG-V2 Pro",
    battery: 95,
    status: "online",
    boundVisitor: "孙丽",
    trip: "YC20260601-C",
    pairingCode: "029384",
    lastOnline: "2026-06-01 14:31:09",
    firmware: "v2.3.1",
    ship: "葛洲坝号",
    group: "傍晚批次",
  },
  {
    id: "9",
    deviceNo: "A009",
    mac: "AC:23:3F:A4:12:B9",
    model: "TG-V2 Lite",
    battery: 8,
    status: "low_battery",
    boundVisitor: "周杰",
    trip: "YC20260601-C",
    pairingCode: "475829",
    lastOnline: "2026-06-01 13:45:30",
    firmware: "v2.2.8",
    ship: "葛洲坝号",
    group: "傍晚批次",
  },
  {
    id: "10",
    deviceNo: "A010",
    mac: "AC:23:3F:A4:12:BA",
    model: "TG-V2 Pro",
    battery: 100,
    status: "maintenance",
    boundVisitor: null,
    trip: null,
    pairingCode: null,
    lastOnline: "2026-05-31 16:22:10",
    firmware: "v2.3.1",
    ship: "长江壹号",
    group: "维修中",
  },
  {
    id: "11",
    deviceNo: "A011",
    mac: "AC:23:3F:A4:12:BB",
    model: "TG-V2 Pro",
    battery: 72,
    status: "online",
    boundVisitor: "吴敏",
    trip: "YC20260601-A",
    pairingCode: "918273",
    lastOnline: "2026-06-01 14:29:55",
    firmware: "v2.3.1",
    ship: "长江壹号",
    group: "上午批次",
  },
  {
    id: "12",
    deviceNo: "A012",
    mac: "AC:23:3F:A4:12:BC",
    model: "TG-V2 Lite",
    battery: 56,
    status: "online",
    boundVisitor: "郑浩",
    trip: "YC20260601-B",
    pairingCode: "564738",
    lastOnline: "2026-06-01 14:27:18",
    firmware: "v2.2.8",
    ship: "三峡盛世",
    group: "下午批次",
  },
  {
    id: "13",
    deviceNo: "A013",
    mac: "AC:23:3F:A4:12:BD",
    model: "TG-V2 Pro",
    battery: 22,
    status: "offline",
    boundVisitor: null,
    trip: null,
    pairingCode: null,
    lastOnline: "2026-06-01 11:05:42",
    firmware: "v2.3.0",
    ship: "葛洲坝号",
    group: "备用",
  },
  {
    id: "14",
    deviceNo: "A014",
    mac: "AC:23:3F:A4:12:BE",
    model: "TG-V2 Pro",
    battery: 89,
    status: "online",
    boundVisitor: "黄静",
    trip: "YC20260601-C",
    pairingCode: "302918",
    lastOnline: "2026-06-01 14:33:01",
    firmware: "v2.3.1",
    ship: "葛洲坝号",
    group: "傍晚批次",
  },
  {
    id: "15",
    deviceNo: "A015",
    mac: "AC:23:3F:A4:12:BF",
    model: "TG-V2 Lite",
    battery: 41,
    status: "weak",
    boundVisitor: "杨帆",
    trip: "YC20260601-A",
    pairingCode: "748291",
    lastOnline: "2026-06-01 14:00:15",
    firmware: "v2.2.8",
    ship: "长江壹号",
    group: "上午批次",
  },
  {
    id: "16",
    deviceNo: "A016",
    mac: "AC:23:3F:A4:12:C0",
    model: "TG-V2 Pro",
    battery: 76,
    status: "online",
    boundVisitor: null,
    trip: null,
    pairingCode: null,
    lastOnline: "2026-06-01 14:20:38",
    firmware: "v2.3.1",
    ship: "三峡盛世",
    group: "备用",
  },
  {
    id: "17",
    deviceNo: "A017",
    mac: "AC:23:3F:A4:12:C1",
    model: "TG-V2 Pro",
    battery: 12,
    status: "low_battery",
    boundVisitor: "林小红",
    trip: "YC20260601-B",
    pairingCode: "182736",
    lastOnline: "2026-06-01 13:55:49",
    firmware: "v2.3.1",
    ship: "三峡盛世",
    group: "下午批次",
  },
  {
    id: "18",
    deviceNo: "A018",
    mac: "AC:23:3F:A4:12:C2",
    model: "TG-V2 Lite",
    battery: 68,
    status: "online",
    boundVisitor: "何伟",
    trip: "YC20260601-C",
    pairingCode: "495867",
    lastOnline: "2026-06-01 14:26:33",
    firmware: "v2.2.8",
    ship: "葛洲坝号",
    group: "傍晚批次",
  },
  {
    id: "19",
    deviceNo: "A019",
    mac: "AC:23:3F:A4:12:C3",
    model: "TG-V2 Pro",
    battery: 55,
    status: "offline",
    boundVisitor: null,
    trip: null,
    pairingCode: null,
    lastOnline: "2026-06-01 10:30:12",
    firmware: "v2.3.0",
    ship: "长江壹号",
    group: "备用",
  },
  {
    id: "20",
    deviceNo: "A020",
    mac: "AC:23:3F:A4:12:C4",
    model: "TG-V2 Pro",
    battery: 93,
    status: "online",
    boundVisitor: "谢雪",
    trip: "YC20260601-A",
    pairingCode: "637481",
    lastOnline: "2026-06-01 14:34:22",
    firmware: "v2.3.1",
    ship: "长江壹号",
    group: "上午批次",
  },
];

export const shipOptions = ["全部船次", "长江壹号", "三峡盛世", "葛洲坝号"];

export const statusOptions = [
  { label: "全部状态", value: "all" },
  { label: "在线", value: "online" },
  { label: "弱连接", value: "weak" },
  { label: "离线", value: "offline" },
  { label: "低电", value: "low_battery" },
  { label: "维护中", value: "maintenance" },
];

export const groupOptions = [
  "全部分组",
  "上午批次",
  "下午批次",
  "傍晚批次",
  "备用",
  "维修中",
];

// ==================== 装机测试数据 ====================

export type InstallStep = "checkin" | "hardware" | "firmware" | "pairing" | "qa" | "ready";

export const installStepConfig: Record<InstallStep, { label: string; icon: string; description: string }> = {
  checkin: { label: "入库登记", icon: "ri-inbox-line", description: "设备扫码入库，登记基本信息" },
  hardware: { label: "硬件检测", icon: "ri-cpu-line", description: "屏幕、摄像头、麦克风、扬声器、电池检测" },
  firmware: { label: "固件刷写", icon: "ri-terminal-box-line", description: "刷入最新固件版本并验证" },
  pairing: { label: "配对测试", icon: "ri-bluetooth-line", description: "蓝牙/WiFi连接测试，扫码配对验证" },
  qa: { label: "整机质检", icon: "ri-shield-check-line", description: "全功能检测，出厂质检报告" },
  ready: { label: "入库就绪", icon: "ri-check-double-line", description: "质检通过，设备可发放使用" },
};

export const installSteps: InstallStep[] = ["checkin", "hardware", "firmware", "pairing", "qa", "ready"];

export interface InstallDevice {
  id: string;
  deviceNo: string;
  mac: string;
  model: string;
  batchNo: string;
  currentStep: InstallStep;
  stepIndex: number;
  tester: string;
  startTime: string;
  estimatedFinish: string;
  hardwareCheck?: {
    screen: boolean;
    camera: boolean;
    mic: boolean;
    speaker: boolean;
    battery: boolean;
    passed: number;
    total: number;
  };
  firmwareVersion?: string;
  firmwareStatus?: "pending" | "flashing" | "verified";
  pairingStatus?: "pending" | "testing" | "passed" | "failed";
  qaStatus?: "pending" | "in_progress" | "passed" | "failed";
  qaChecklist?: { item: string; passed: boolean }[];
  notes: string;
}

export const installStats = {
  total: 58,
  checkin: 10,
  hardware: 8,
  firmware: 12,
  pairing: 9,
  qa: 11,
  ready: 8,
  todayCompleted: 15,
};

export const installDevices: InstallDevice[] = [
  {
    id: "ins-01",
    deviceNo: "A101",
    mac: "AC:23:3F:B1:01:AA",
    model: "TG-V2 Pro",
    batchNo: "BATCH-20260609-01",
    currentStep: "checkin",
    stepIndex: 0,
    tester: "王工程师",
    startTime: "2026-06-09 08:30:00",
    estimatedFinish: "2026-06-09 09:15:00",
    hardwareCheck: { screen: true, camera: true, mic: true, speaker: true, battery: true, passed: 5, total: 5 },
    notes: "新到货设备，等待检测",
  },
  {
    id: "ins-02",
    deviceNo: "A102",
    mac: "AC:23:3F:B1:02:AB",
    model: "TG-V2 Pro",
    batchNo: "BATCH-20260609-01",
    currentStep: "hardware",
    stepIndex: 1,
    tester: "王工程师",
    startTime: "2026-06-09 08:35:00",
    estimatedFinish: "2026-06-09 09:20:00",
    hardwareCheck: { screen: true, camera: true, mic: true, speaker: false, battery: true, passed: 4, total: 5 },
    notes: "扬声器待复检",
  },
  {
    id: "ins-03",
    deviceNo: "A103",
    mac: "AC:23:3F:B1:03:AC",
    model: "TG-V2 Pro",
    batchNo: "BATCH-20260609-01",
    currentStep: "hardware",
    stepIndex: 1,
    tester: "王工程师",
    startTime: "2026-06-09 08:40:00",
    estimatedFinish: "2026-06-09 09:25:00",
    hardwareCheck: { screen: true, camera: true, mic: true, speaker: true, battery: true, passed: 5, total: 5 },
    notes: "硬件全部通过",
  },
  {
    id: "ins-04",
    deviceNo: "A104",
    mac: "AC:23:3F:B1:04:AD",
    model: "TG-V2 Lite",
    batchNo: "BATCH-20260609-01",
    currentStep: "firmware",
    stepIndex: 2,
    tester: "李工程师",
    startTime: "2026-06-09 08:45:00",
    estimatedFinish: "2026-06-09 09:30:00",
    firmwareVersion: "v2.3.1",
    firmwareStatus: "flashing",
    notes: "固件刷写中…",
  },
  {
    id: "ins-05",
    deviceNo: "A105",
    mac: "AC:23:3F:B1:05:AE",
    model: "TG-V2 Pro",
    batchNo: "BATCH-20260609-01",
    currentStep: "firmware",
    stepIndex: 2,
    tester: "李工程师",
    startTime: "2026-06-09 08:50:00",
    estimatedFinish: "2026-06-09 09:35:00",
    firmwareVersion: "v2.3.1",
    firmwareStatus: "verified",
    notes: "固件刷写完成，版本验证通过",
  },
  {
    id: "ins-06",
    deviceNo: "A106",
    mac: "AC:23:3F:B1:06:AF",
    model: "TG-V2 Lite",
    batchNo: "BATCH-20260609-01",
    currentStep: "firmware",
    stepIndex: 2,
    tester: "李工程师",
    startTime: "2026-06-09 08:55:00",
    estimatedFinish: "2026-06-09 09:40:00",
    firmwareVersion: "v2.3.1",
    firmwareStatus: "flashing",
    notes: "固件刷写中…",
  },
  {
    id: "ins-07",
    deviceNo: "A107",
    mac: "AC:23:3F:B1:07:B0",
    model: "TG-V2 Pro",
    batchNo: "BATCH-20260609-01",
    currentStep: "pairing",
    stepIndex: 3,
    tester: "张工程师",
    startTime: "2026-06-09 09:00:00",
    estimatedFinish: "2026-06-09 09:45:00",
    pairingStatus: "testing",
    notes: "蓝牙配对测试中",
  },
  {
    id: "ins-08",
    deviceNo: "A108",
    mac: "AC:23:3F:B1:08:B1",
    model: "TG-V2 Pro",
    batchNo: "BATCH-20260609-01",
    currentStep: "pairing",
    stepIndex: 3,
    tester: "张工程师",
    startTime: "2026-06-09 09:05:00",
    estimatedFinish: "2026-06-09 09:50:00",
    pairingStatus: "passed",
    notes: "蓝牙/WiFi 配对测试通过",
  },
  {
    id: "ins-09",
    deviceNo: "A109",
    mac: "AC:23:3F:B1:09:B2",
    model: "TG-V2 Lite",
    batchNo: "BATCH-20260609-01",
    currentStep: "pairing",
    stepIndex: 3,
    tester: "张工程师",
    startTime: "2026-06-09 09:10:00",
    estimatedFinish: "2026-06-09 09:55:00",
    pairingStatus: "failed",
    notes: "WiFi 模块连接不稳定，需复检",
  },
  {
    id: "ins-10",
    deviceNo: "A110",
    mac: "AC:23:3F:B1:0A:B3",
    model: "TG-V2 Pro",
    batchNo: "BATCH-20260609-01",
    currentStep: "qa",
    stepIndex: 4,
    tester: "赵工程师",
    startTime: "2026-06-09 09:15:00",
    estimatedFinish: "2026-06-09 10:00:00",
    qaStatus: "in_progress",
    qaChecklist: [
      { item: "屏幕显示正常", passed: true },
      { item: "触摸响应灵敏", passed: true },
      { item: "摄像头拍照清晰", passed: true },
      { item: "麦克风收音正常", passed: true },
      { item: "扬声器音质清晰", passed: false },
      { item: "GPS 定位准确", passed: true },
      { item: "蓝牙连接稳定", passed: true },
      { item: "WiFi 信号正常", passed: true },
      { item: "电池续航达标", passed: true },
      { item: "外观无划痕", passed: true },
    ],
    notes: "扬声器音质需复检",
  },
  {
    id: "ins-11",
    deviceNo: "A111",
    mac: "AC:23:3F:B1:0B:B4",
    model: "TG-V2 Pro",
    batchNo: "BATCH-20260609-01",
    currentStep: "qa",
    stepIndex: 4,
    tester: "赵工程师",
    startTime: "2026-06-09 09:20:00",
    estimatedFinish: "2026-06-09 10:05:00",
    qaStatus: "passed",
    qaChecklist: [
      { item: "屏幕显示正常", passed: true },
      { item: "触摸响应灵敏", passed: true },
      { item: "摄像头拍照清晰", passed: true },
      { item: "麦克风收音正常", passed: true },
      { item: "扬声器音质清晰", passed: true },
      { item: "GPS 定位准确", passed: true },
      { item: "蓝牙连接稳定", passed: true },
      { item: "WiFi 信号正常", passed: true },
      { item: "电池续航达标", passed: true },
      { item: "外观无划痕", passed: true },
    ],
    notes: "质检全部通过，等待入库",
  },
  {
    id: "ins-12",
    deviceNo: "A112",
    mac: "AC:23:3F:B1:0C:B5",
    model: "TG-V2 Lite",
    batchNo: "BATCH-20260609-01",
    currentStep: "qa",
    stepIndex: 4,
    tester: "赵工程师",
    startTime: "2026-06-09 09:25:00",
    estimatedFinish: "2026-06-09 10:10:00",
    qaStatus: "failed",
    qaChecklist: [
      { item: "屏幕显示正常", passed: true },
      { item: "触摸响应灵敏", passed: true },
      { item: "摄像头拍照清晰", passed: false },
      { item: "麦克风收音正常", passed: true },
      { item: "扬声器音质清晰", passed: true },
      { item: "GPS 定位准确", passed: false },
      { item: "蓝牙连接稳定", passed: true },
      { item: "WiFi 信号正常", passed: true },
      { item: "电池续航达标", passed: true },
      { item: "外观无划痕", passed: true },
    ],
    notes: "摄像头模糊 + GPS 定位偏移，需返修",
  },
  {
    id: "ins-13",
    deviceNo: "A113",
    mac: "AC:23:3F:B1:0D:B6",
    model: "TG-V2 Pro",
    batchNo: "BATCH-20260609-01",
    currentStep: "ready",
    stepIndex: 5,
    tester: "赵工程师",
    startTime: "2026-06-09 08:00:00",
    estimatedFinish: "2026-06-09 08:45:00",
    notes: "质检通过，已入库就绪",
  },
  {
    id: "ins-14",
    deviceNo: "A114",
    mac: "AC:23:3F:B1:0E:B7",
    model: "TG-V2 Pro",
    batchNo: "BATCH-20260609-01",
    currentStep: "ready",
    stepIndex: 5,
    tester: "赵工程师",
    startTime: "2026-06-09 08:05:00",
    estimatedFinish: "2026-06-09 08:50:00",
    notes: "质检通过，已入库就绪",
  },
  {
    id: "ins-15",
    deviceNo: "A115",
    mac: "AC:23:3F:B1:0F:B8",
    model: "TG-V2 Lite",
    batchNo: "BATCH-20260609-01",
    currentStep: "ready",
    stepIndex: 5,
    tester: "赵工程师",
    startTime: "2026-06-09 08:10:00",
    estimatedFinish: "2026-06-09 08:55:00",
    notes: "质检通过，已入库就绪",
  },
];

export const installBatches = [
  { batchNo: "BATCH-20260609-01", count: 15, status: "进行中", date: "2026-06-09" },
  { batchNo: "BATCH-20260608-01", count: 20, status: "已完成", date: "2026-06-08" },
  { batchNo: "BATCH-20260607-01", count: 23, status: "已完成", date: "2026-06-07" },
];

export const deviceDetailHistory = [
  { time: "2026-06-01 14:32:18", event: "已配对，绑定游客陈明远", type: "pair" },
  { time: "2026-06-01 14:15:33", event: "电量降至 20%，推送低电提醒", type: "alert" },
  { time: "2026-06-01 08:30:00", event: "设备上线，固件 v2.3.1", type: "online" },
  { time: "2026-05-31 18:45:12", event: "已解绑，游客行程结束", type: "unpair" },
  { time: "2026-05-31 08:15:00", event: "已配对，绑定游客李明", type: "pair" },
  { time: "2026-05-30 22:10:00", event: "设备离线，进入充电模式", type: "offline" },
];

export const deviceMaintenanceRecords = [
  { date: "2026-05-15", type: "固件升级", content: "升级至 v2.3.1，修复蓝牙连接稳定性", staff: "张工程师" },
  { date: "2026-04-20", type: "硬件检修", content: "更换电池模组，容量恢复至 100%", staff: "王工程师" },
  { date: "2026-03-10", type: "常规保养", content: "清洁镜片、检查麦克风和扬声器", staff: "李工程师" },
];